module.exports = __webpack_public_path__ + "static/media/stp_card_cvc_amex.37c69d81.png";